import Vue from 'vue'

//定义预载指令
Vue.directive('preload', {
    bind: function (el, binding) {
        let img = new Image()
        img.src = binding.value
        img.onload = function () {
            el.src = binding.value
        }
    }
})